import { useState, useEffect } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import moment from "moment";
import Swal from "sweetalert2";

const MAX_RANGE_DAYS = 62;

const CustomDatePicker = ({ onDateChange, valueStart, valueEnd }) => {
    const [value, setValue] = useState({
        startDate: valueStart || null,
        endDate: valueEnd || null,
    });

    useEffect(() => {
        const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
        const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

        setValue({
            startDate: valueStart || startOfMonth,
            endDate: valueEnd || endOfMonth,
        });
    }, [valueStart, valueEnd]);

    const handleChange = (newValue) => {
        if (!newValue?.startDate || !newValue?.endDate) {
            setValue(newValue);
            return;
        }

        const start = moment(newValue.startDate);
        const end = moment(newValue.endDate);
        const diffDays = end.diff(start, "days") + 1;

        if (diffDays > MAX_RANGE_DAYS) {
            Swal.fire({
                icon: "warning",
                title: "Periodo troppo lungo",
                text: `Puoi selezionare un periodo massimo di ${MAX_RANGE_DAYS} giorni`,
                confirmButtonText: "Ok",
            });

            return;
        }

        setValue(newValue);
        if (onDateChange) {
            onDateChange(newValue.startDate, newValue.endDate);
        }
    };

    return (
        <div className="relative w-full overflow-visible">
            <Datepicker
                i18n="it"
                startWeekOn="mon"
                separator=" - "
                displayFormat="DD/MM/YYYY"
                primaryColor="indigo"
                value={value}
                onChange={handleChange}
                showShortcuts={false}
                popoverDirection="down"
                containerClassName="relative w-full"
                inputClassName="h-10 w-full rounded-lg border border-gray-300 bg-white px-3 text-sm text-gray-700 shadow-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                toggleClassName="absolute right-0 h-full px-3 text-gray-400 hover:text-indigo-600"
            />
        </div>
    );
};

export default CustomDatePicker;
